import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription, throwError } from 'rxjs';
import { catchError, delay, delayWhen, filter, map, mergeMap, switchMap, take, tap, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SessionService } from './session.service';
import { AuthService } from './auth.service';


@Injectable({
  providedIn: 'root'
})
export class AuthInterceptorService implements HttpInterceptor {
  private router: Router;
  private token: string;
  private refreshingToken: boolean = false;
  public tokenSubject$: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private readonly exclusionPaths: string[] = [
    'login',
    'assets',
    'token'
  ];

  refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null)

  constructor(
    public _auth: AuthService,
    public _session: SessionService,
    public http: HttpClient) {
    
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this._session.token
    // request no necesita token en headers
    if (this.isUrlOnExcludedPaths(req.url)) {
      return next.handle((req));
    }

    // SI existe el token, agregarlo a la request
    if (token) req = this.addToken(req, token);
    //ejecutar a la request
    return next.handle(req).pipe(catchError(error => {
      if (error instanceof HttpErrorResponse && error.status === 401) {
        return this.handle401Error(req, next);
      }
      else return throwError(error);
    }));

  }//cierre del metodo


  
  private isUrlOnExcludedPaths = (url: string) =>
    this.exclusionPaths.some(path => url.includes(path))


    
  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this._session.isRefreshing) {

      this._session.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this._auth.refreshToken().pipe(
        switchMap((token: any) => {
          this._session.isRefreshing = false;
          this.refreshTokenSubject.next(token['access_token']);
          return next.handle(this.addToken(request, token['access_token']));
        }));
    }
    else {
      return this.refreshTokenSubject.pipe(
        filter(token => token != null),
        take(1),
        switchMap(jwt => {
          return next.handle(this.addToken(request, jwt));
        }));
    }
  }


  private addToken(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        'Authorization': `Bearer ${token}`
      }
    });
  }







  
}
